module.exports = __webpack_public_path__ + "img/cloud-upload.69853a50.svg";